import { products } from "../../data/products.js";

export function MotionStrip() {
  const items = products.map((product) => `<span><i></i>${product.name}</span>`).join("");
  return `
    <div class="motion-strip" aria-label="Productos conectados de GR SoftMedia">
      <div class="motion-strip-track">
        <div>${items}<span><i></i>Integraciones</span><span><i></i>Automatización</span></div>
        <div aria-hidden="true">${items}<span><i></i>Integraciones</span><span><i></i>Automatización</span></div>
      </div>
    </div>
  `;
}
